var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/still-image.tsx";
import classNames from 'clsx';
import React, { useRef } from 'react';
import { useSettings } from 'soapbox/hooks';

/** Renders images on a canvas, only playing GIFs if autoPlayGif is enabled. */
const StillImage = _ref => {
  let {
    alt,
    className,
    src,
    style,
    letterboxed = false,
    showExt = false
  } = _ref;
  const settings = useSettings();
  const autoPlayGif = settings.get('autoPlayGif');
  const canvas = useRef(null);
  const img = useRef(null);
  const hoverToPlay = src && !autoPlayGif && (src.endsWith('.gif') || src.startsWith('blob:'));

  const handleImageLoad = () => {
    if (hoverToPlay && canvas.current && img.current) {
      var _canvas$current$getCo;

      canvas.current.width = img.current.naturalWidth;
      canvas.current.height = img.current.naturalHeight;
      (_canvas$current$getCo = canvas.current.getContext('2d')) === null || _canvas$current$getCo === void 0 ? void 0 : _canvas$current$getCo.drawImage(img.current, 0, 0);
    }
  };
  /** ClassNames shared between the `<img>` and `<canvas>` elements. */


  const baseClassName = classNames('w-full h-full block', {
    'object-contain': letterboxed,
    'object-cover': !letterboxed
  });
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "still-image-container",
    className: classNames(className, 'relative group overflow-hidden isolate'),
    style: style,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: alt,
    ref: img,
    onLoad: handleImageLoad,
    className: classNames(baseClassName, {
      'invisible group-hover:visible': hoverToPlay
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 7
    }
  }), hoverToPlay && /*#__PURE__*/React.createElement("canvas", {
    ref: canvas,
    className: classNames(baseClassName, {
      'group-hover:invisible': hoverToPlay
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 9
    }
  }), hoverToPlay && showExt && /*#__PURE__*/React.createElement("div", {
    className: "group-hover:hidden absolute opacity-90 left-2 bottom-2 pointer-events-none",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 73,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(ExtensionBadge, {
    ext: "GIF",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 11
    }
  })));
};

/** Badge displaying a file extension. */
const ExtensionBadge = _ref2 => {
  let {
    ext
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: "inline-flex items-center px-2 py-0.5 rounded text-sm font-medium bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-gray-100",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 5
    }
  }, ext);
};

export default StillImage;